import { Controller } from "stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["image", "spinner", "label"];

  connect() {
    this.rotation = 0;
    this.currentTrigger = null;
    this.boundKeydown = this.handleKeydown.bind(this);

    this.element.addEventListener("show.bs.modal", this.handleShow.bind(this));
    this.element.addEventListener(
      "hidden.bs.modal",
      this.handleHidden.bind(this),
    );
    this.element.addEventListener("click", this.handleBackdropClick.bind(this));
    document.addEventListener("keydown", this.boundKeydown);

    this.imageTarget.addEventListener("load", this.handleImageLoad.bind(this));
    this.imageTarget.addEventListener("error", this.handleImageLoad.bind(this));
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown);
  }

  getAllTriggers() {
    return Array.from(
      document.querySelectorAll(`[data-bs-target="#${this.element.id}"]`),
    ).filter((el) => el.offsetParent !== null);
  }

  showImage(trigger) {
    if (!trigger) return;
    this.currentTrigger = trigger;
    const imageUrl = trigger.getAttribute("data-preview-image");
    const label = trigger.getAttribute("data-preview-label");

    if (imageUrl) {
      this.spinnerTarget.style.display = "inline-block";
      this.imageTarget.style.display = "none";
      this.imageTarget.src = imageUrl;
    }

    this.labelTarget.textContent = label || "";
    this.rotation = 0;
    this.imageTarget.style.transform = "rotate(0deg)";
  }

  navigate(direction) {
    const triggers = this.getAllTriggers();
    const currentIndex = triggers.indexOf(this.currentTrigger);
    if (currentIndex === -1) return;

    const newIndex = currentIndex + direction;
    if (newIndex >= 0 && newIndex < triggers.length) {
      this.showImage(triggers[newIndex]);
    }
  }

  handleImageLoad() {
    this.spinnerTarget.style.display = "none";
    this.imageTarget.style.display = "inline";
  }

  rotateLeft() {
    this.rotation -= 90;
    this.imageTarget.style.transform = `rotate(${this.rotation}deg)`;
  }

  rotateRight() {
    this.rotation += 90;
    this.imageTarget.style.transform = `rotate(${this.rotation}deg)`;
  }

  handleShow(event) {
    this.currentTrigger = event.relatedTarget;
    this.showImage(this.currentTrigger);
  }

  handleHidden() {
    this.rotation = 0;
    this.imageTarget.style.transform = "rotate(0deg)";
    this.currentTrigger = null;
  }

  handleBackdropClick(event) {
    if (event.target.closest("button") || event.target === this.imageTarget)
      return;

    const modal = Modal.getInstance(this.element);
    if (modal) modal.hide();
  }

  handleKeydown(event) {
    if (!this.element.classList.contains("show")) return;
    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;

    if (event.key === "ArrowLeft") {
      event.preventDefault();
      this.navigate(-1);
    } else if (event.key === "ArrowRight") {
      event.preventDefault();
      this.navigate(1);
    }
  }
}
